import { PermitStep } from "@ha/data/basic";

export namespace PermitPhotoActions {
    export class SavePermitPhoto {
        public static readonly type = "[PermitPhoto] SavePermitPhoto";
        constructor(
            public permitId: number,
            public photo: File,
            public step: PermitStep = PermitStep.photo,
            public questionId?: number,
        ) {}
    }

    export class RemovePermitPhoto {
        public static readonly type = "[PermitPhoto] RemovePermitPhoto";
        constructor(public fileName: string) {}
    }

    export class GetPermitPhotos {
        public static readonly type = "[PermitPhoto] GetPermitPhotos";
        constructor(public language: string, public includeLinkedFlammableAtexPhotos = false) {}
    }

    export class GetPermitPhotoRequirement {
        public static readonly type = "[PermitPhoto] GetPermitPhotoRequirement";
    }

    export class ClearPhotos {
        public static readonly type = "[PermitPhoto] ClearPhotos";
    }
}
